import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimeTracking = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_203_6110)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_203_6110",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_203_6110)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M15.523 16.2959L16.452 15.3669L12.65 11.5649V6.2189H11.35V12.1226L15.523 16.2959ZM12.0018 21.3189C10.7483 21.3189 9.56994 21.0821 8.46678 20.6084C7.36378 20.1347 6.39719 19.483 5.56702 18.6531C4.73686 17.8233 4.08477 16.8559 3.61077 15.7509C3.13694 14.6461 2.90002 13.4655 2.90002 12.2091C2.90002 10.9528 3.13686 9.77156 3.61052 8.6654C4.08419 7.55923 4.73594 6.59523 5.56577 5.7734C6.39561 4.95156 7.36303 4.30365 8.46803 3.82965C9.57286 3.35581 10.7534 3.1189 12.0098 3.1189C13.2661 3.1189 14.4474 3.35773 15.5535 3.8354C16.6599 4.31306 17.6222 4.96131 18.4405 5.78015C19.2589 6.59898 19.9067 7.5619 20.384 8.6689C20.8614 9.7759 21.1 10.9586 21.1 12.2171C21.1 13.4706 20.8632 14.649 20.3895 15.7521C19.9159 16.8551 19.2683 17.8217 18.4468 18.6519C17.6253 19.4821 16.6606 20.1341 15.5528 20.6081C14.4449 21.082 13.2613 21.3189 12.0018 21.3189ZM12.012 20.0189C14.1699 20.0189 16.0074 19.2564 17.5245 17.7314C19.0415 16.2064 19.8 14.3649 19.8 12.2069C19.8 10.0491 19.0415 8.21156 17.5245 6.6944C16.0074 5.1774 14.1699 4.4189 12.012 4.4189C9.85402 4.4189 8.01253 5.1774 6.48752 6.6944C4.96252 8.21156 4.20002 10.0491 4.20002 12.2069C4.20002 14.3649 4.96252 16.2064 6.48752 17.7314C8.01253 19.2564 9.85402 20.0189 12.012 20.0189Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_203_6110",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgTimeTracking;
